import { connectRouter } from "connected-react-router";
import { combineReducers, Reducer } from "redux";
import user from "reducers/user";
import jobs from "reducers/jobs";
import open from "reducers/open";
import balance from "reducers/balance";
import file from "reducers/file";
import teams from "reducers/teams";
import createAnimation from "reducers/createAnimation";
import { History } from "history";

const createRootReducers = (history: History): Reducer<sage.state.IRedux> =>
    combineReducers({
        router: connectRouter(history),
        user,
        jobs,
        open,
        balance,
        file,
        teams,
        createAnimation,
    });

export default createRootReducers;
